/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import PropTypes from 'prop-types';

import breakpoints from '../../theme/breakpoints';

import { Section, BackgroundContainer } from './styles';

const isMobileWindow = (width) => {
  if (width > breakpoints.values.medium) {
    return false;
  }
  return true;
};

export const HeroComponent = (props) => {
  const [isImageLoaded, setImageLoaded] = useState(false);
  const [isMobileImage, setIsMobileImage] = useState(false);
  const isMobile = isMobileWindow(typeof window !== 'undefined' ? window.innerWidth : false);
  const [lowResImage, setLowResImage] = useState(() => (!isMobile ? props.backgroundImageMobileLowRes : props.backgroundImageLowRes));
  const [highResImage, setHighResImage] = useState(() => (isMobile ? props.backgroundImageMobileHighRes : props.backgroundImageHighRes));

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // browser-only code - react-static has some server side rendering for build process
      window.addEventListener(
        'resize',
        throttle(() => {
          const mobile = isMobileWindow(window.innerWidth);
          if (mobile !== isMobileImage) {
            setIsMobileImage(mobile);
            setLowResImage(
              !mobile
                ? props.backgroundImageMobileLowRes
                : props.backgroundImageLowRes,
            );
            setHighResImage(
              mobile
                ? props.backgroundImageMobileHighRes
                : props.backgroundImageHighRes,
            );
          }
        }, 100),
      );
    }
  });

  useEffect(() => {
    const img = new Image();
    setImageLoaded(false);

    img.onload = () => setImageLoaded(true);

    img.src = highResImage;
  }, [highResImage]);

  return (
    <Section id="section-home-hero" role="banner" styles={props.classes.Section || {}}>
      <BackgroundContainer
        loading={!isImageLoaded}
        highResImage={highResImage}
        lowResImage={lowResImage}
        styles={props.classes.Background || {}}
      />
      {props.innerContent && props.innerContent}
    </Section>
  );
};

HeroComponent.propTypes = {
  /** DESKTOP -The final high res asset location/src for the background image */
  backgroundImageHighRes: PropTypes.string.isRequired,
  /** DESKTOP - Temp low res image for initial render on page load - replaced once high res image loads */
  backgroundImageLowRes: PropTypes.string.isRequired,
  /** MOBILE -The final high res asset location/src for the background image */
  backgroundImageMobileHighRes: PropTypes.string.isRequired,
  /** MOBILE - Temp low res image for initial render on page load - replaced once high res image loads */
  backgroundImageMobileLowRes: PropTypes.string.isRequired,
  /** Inner content/react code to place on top of the hero (Title, CTA, etc) */
  innerContent: PropTypes.any,
  /** Override or extend the styles applied to the component using styled components css. Section and Background are available to pass styles into */
  classes: PropTypes.object,
};

HeroComponent.defaultProps = {
  classes: { Section: '', Background: '' },
};

export default HeroComponent;
